export enum CalledCategoryEnum {
  BUG,
  SEGESTAO_MELHORIA,
  DUVIDA,
  OUTRO,
}

const calledCategoryLabels: Record<CalledCategoryEnum, string> = {
  [CalledCategoryEnum.BUG]: "BUG",
  [CalledCategoryEnum.SEGESTAO_MELHORIA]: "Sugestão ou melhoria",
  [CalledCategoryEnum.DUVIDA]: "Dúvida",
  [CalledCategoryEnum.OUTRO]: "Outro",
};

export function calledCategoryToString(
  category: CalledCategoryEnum | null | undefined
): string {
  if (category === undefined || category === null) return "Desconhecido";
  return calledCategoryLabels[category];
}

export type Called = {
  name: string;
  email: string;
  categoria: CalledCategoryEnum;
  descricao: string;
  anexos: {
    documentLink: string;
    documentName: string;
    documentType: string;
  }[];
  code: number;
};
